<template>
  <div class="userCenter">
    <div class="boxCenter">
      <div class="userBox">
        <LeftSide></LeftSide>
        <div class="userRight">
          <div class="userTitle">订单确认</div>
          <div class="fenceTitle" style="margin-top: 10px;">确认收货地址</div>
          <div class="addressBox">
            <div class="addressItem" v-for="(item,index) in addrelistData" :key="index">
              <p :title="item.areaName.replace(/,/g,'')+item.address+item.name+item.phone">{{item.areaName.replace(/,/g,'')}}{{item.address}}（{{item.name}}  收）  {{item.phone}}</p>
              <span class="selecteBtn" :class="{'active' : deliverId === item.id}" @click="selectAddress(item.id)"></span>
              <span class="eidt" @click="update(item)">修改地址</span>
              <span class="eidt" v-if="item.isDefault == 2" @click="setDefaultFn(item.id)">设为默认</span>
              <span class="defalse" v-if="item.isDefault == 1">默认地址</span>
              <span class="deleteBtn" @click="deleteAddress(item.id)"></span>
            </div>
            <div class="useNewAdd"><span @click="newAddress">使用新地址</span> *注：收货地址最多只能保存3条</div>
            <div class="addressItem">
              上门自提
              <span class="selecteBtn" :class="{'active' : deliverId === 0}" @click="selectAddress(0)"></span>
            </div>
          </div>
          <div class="fenceTitle" style="margin-top: 10px;">支付方式</div>
          <div class="radioPayFor">
            <label :sele="payType == 1 ? 'sele' : ''" @click="payType=1">线上支付</label>
            <label :sele="payType == 2 ? 'sele' : ''" @click="payType=2">线下支付</label>
          </div>

          <div class="fenceTitle" style="margin-top: 10px;">商品信息</div>
          <div class="listTh">
            <el-row>
              <el-col :span="14">订单详情</el-col>
              <el-col :span="3">单价</el-col>
              <el-col :span="3">数量</el-col>
              <el-col :span="4">金额</el-col>
            </el-row>
          </div>
          <div class="orderList">
            <ul>
              <li style="margin-bottom: 10px;">
                <!-- <div class="itemT">订单时间：{{item.createDate}} &nbsp;&nbsp; 订单编号：{{item.orderCode}}</div> -->
                <div class="itemC">
                  <el-row class="proInfo" v-for="(item,index) in goodsOrderDetails" :key="index">
                    <el-col :span="14">
                      <div class="imgBox"><router-link :to="'/productDetails/'+item.goodsId"><img :src="item.pic"></router-link></div>
                      <div class="infoBox">
                        <p class="p1">{{item.name}}</p>
                        <p class="p2">{{item.property}}</p>
                      </div>
                    </el-col>
                    <el-col :span="3">
                      <div class="itemTd price">￥{{item.memberPrice.toFixed(2)}}</div>
                    </el-col>
                    <el-col :span="3">
                      <div class="itemTd num">x{{item.num}}</div>
                    </el-col>
                    <el-col :span="4">
                      <div class="itemTd pay">￥{{(parseFloat(item.memberPrice) * parseFloat(item.num)).toFixed(2)}}</div>
                    </el-col>
                  </el-row>
                  <el-row class="priceInfo" style="margin-top: 10px;text-align: right;">
                    <el-col :span="18" class="lT">获得积分：</el-col>
                    <el-col :span="6"  class="rC" style="text-align: right;">{{allCredits}}&nbsp;</el-col>
                  </el-row>
                  <el-row class="priceInfo" style="text-align: right;">
                    <el-col :span="18" class="lT">订单总价：</el-col>
                    <el-col :span="6"  class="rC" style="text-align: right;">￥{{allPrice.toFixed(2)}}&nbsp;</el-col>
                  </el-row>
                  <el-row class="priceInfo" style="text-align: right;">
                    <el-col :span="18" class="lT">实付金额：</el-col>
                    <el-col :span="6"  class="rC" style="text-align: right;">￥{{allMemberPrice.toFixed(2)}}&nbsp;</el-col>
                  </el-row>
                  <el-row class="priceInfo">
                    <el-col :span="18" class="lT">备注信息：</el-col>
                  </el-row>
                  <el-row class="priceInfo">
                    <el-col :span="24" class="lT">
                      <el-input
                        type="textarea"
                        :maxlength="500"
                        :rows="3"
                        placeholder="请输入备注内容"
                        v-model="remark">
                      </el-input>
                      <p style="margin-top: 5px;font-size: 12px;color: #999;">备注信息字数限制500字</p>
                    </el-col>
                  </el-row>
                  <div class="btn-box">
                    <el-button plain @click="goBack">返回</el-button>
                    <el-button type="primary" @click="confirmOrder">提交订单</el-button>
                  </div>
                  <!-- <span class="opBtn cancel" v-if="item.status == 1" @click="cancelOrder(item.id)">取消订单</span>
                  <span class="opBtn pay" v-if="item.status == 1">继续支付</span> -->
                </div>
              </li>
            </ul>
          </div>
          <el-dialog
            title="新增地址"
            :visible.sync="dialogVisible"
            width="520px"
            :before-close="handleClose">
            <div class="userInfoBox">
              <el-form ref="form" :model="objData" :rules="rules" label-width="100px">
                <el-form-item label="收货人姓名" prop="name">
                  <el-input v-model="objData.name" placeholder="请输入收货人姓名"></el-input>
                </el-form-item>
                <!-- <el-form-item label="身份证" prop="idNumber">
                  <el-input v-model="formData.idNumber" placeholder="请输入身份证" :disabled="true"></el-input>
                </el-form-item> -->
                <el-form-item label="手机号码" prop="phone">
                  <el-input v-model="objData.phone" placeholder="请输入手机号码"></el-input>
                </el-form-item>
                <el-form-item label="地址信息" prop="areaCode">
                  <el-cascader
                      v-model="areaCode"
                      :options="areaOption"
                      clearable
                      @change="handleChange">
                  </el-cascader>
                  <input type="hidden" v-model="objData.areaCode" name="">
                </el-form-item>
                <el-form-item label="详细地址" prop="address">
                  <el-input
                    type="textarea"
                    :rows="2"
                    placeholder="请输入详细地址"
                    v-model="objData.address">
                  </el-input>
                </el-form-item>
                <el-form-item label="">
                  <p class="defaultAddress"><label @click="setDefault"><i :class="{'active':objData.isDefault == 1}"></i><span>设置为默认收货地址</span></label></p>
                  <div class="addBtn">
                    <span @click="addSave" class="save">保存</span>
                    <span @click="closeAdd">取消</span>
                  </div>
                  <p class="addTip">注：收货地址最多只能保存3条</p>
                </el-form-item>
              </el-form>
            </div>
          </el-dialog>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import LeftSide from './common/leftside'
  import eventVue from '../bus.js'
  import areaCode from "@/utils/areaCode"
  export default {
    components: {
      LeftSide
    },
    computed: {
      userData() {
        return this.$store.state.userData
      }
    },
    data(){
      return {
        memberId:9,
        orderList:[],
        total:0,
        curPage:1,
        status:1,
        areaCode:'',
        editId:'',

        dialogVisible:false,
        objData:{
          name:'',
          phone:'',
          areaCode:'',
          areaName:'',
          address:'',
          isDefault:2,
        },
        addrelistData:[],
        rules:{
          name:[{required: true, trigger: 'blur',message:'请输入收货人姓名'}],
          phone:[{required: true, trigger: 'blur',message:'请输入手机号码'}],
          areaCode:[{required: true, trigger: 'change',message:'请选择地址'}],
          address:[{required: true, trigger: 'blur',message:'请输入详细地址'}],
        },
        areaOption:areaCode.areavalue,

        goodsOrderDetails:[], //商品列表
        remark:'', //备注
        deliverId:null, //
        cartIds:[], //购物车IDS
        allCredits:0,
        allPrice:0,
        allMemberPrice:0,
        payType : 1, //1线上 2线下
      }
    },
    created(){
      let proArr = JSON.parse(localStorage.getItem('proArr'))
      localStorage.removeItem('proArr')
      if (proArr && proArr.length > 0) {
        let allCredits = 0
        let allPrice = 0
        let allMemberPrice = 0
        proArr.forEach(item => {
          let tempObj = {}
          tempObj.goodsId = item.goodsId
          tempObj.memberPrice = item.memberPrice
          tempObj.name = item.name
          tempObj.num = item.num
          tempObj.pic = item.pic
          tempObj.shopId = item.shopId
          tempObj.price = item.price
          allPrice += (parseFloat(item.memberPrice) * parseInt(item.num))
          allMemberPrice += (parseFloat(item.memberPrice) * parseInt(item.num))
          tempObj.property = item.property
          tempObj.goodsCode = item.goodsCode
          tempObj.credits = (item.points * parseInt(item.num))
          allCredits += (parseInt(item.points) * parseInt(item.num))
          //tempObj.cartIds = item.id
          this.cartIds.push(item.id)
          this.goodsOrderDetails.push(tempObj)
        })
        this.allCredits = allCredits
        this.allPrice = allPrice
        this.allMemberPrice = allMemberPrice
      }
      //this.getOrderList()
      this.getAddressList()
    },
    mounted(){
      eventVue.$emit("leftSwitch",'3')
    },
    methods:{
      selectAddress(id){
        this.deliverId = id
      },
      handleChange(val){
        if(val && val[2]){
          this.objData.areaCode = val.join(',')
          this.objData.areaName = areaCode.getCompleteAddress(val[2])
        }else{
          this.objData.areaCode = ''
          this.objData.areaName = ''
          this.areaCode = []
        }
      },
      /*设为默认*/
      setDefault(){
        if(this.objData.isDefault == 1){
          this.objData.isDefault = 0
        }else{
          this.objData.isDefault = 1
        }
      },
      setDefaultFn(id){
        this.$https.post('/api/address/updateDefaultAddress/id/'+id).then((response)=>{
          if(response.code == 0){
            this.$message.success("操作成功")
            this.getAddressList()
          }else{
            this.$message.warning(res.message)
          }
        });
      },
      getAddressList(){
        this.$https.get('/api/address/memberId/'+this.userData.id).then((response)=>{
          response.data.forEach(item=>{
            if(item.isDefault == 1){
              this.deliverId = item.id
            }
          })
          this.addrelistData = response.data
        });
      },
      handleClose(){
        this.dialogVisible = false
      },
      addSave(){
        this.$refs["form"].validate((valid) => {
          if (valid) {
            this.objData.memberId = this.userData.id
            if(!this.editId){
              this.$https.post('/api/address/addAddress',this.objData).then(res => {
                if(res.code == 0){
                  this.$message.success("操作成功")
                  this.closeAdd()
                  this.getAddressList()
                }else{
                  this.$message.warning(res.msg)
                }
              });
            }else{
              this.objData.id = this.editId
              this.$https.post('/api/address/updateAddress',this.objData).then(res => {
                if(res.code == 0){
                  this.$message.success("操作成功")
                  this.closeAdd()
                  this.getAddressList()
                }else{
                  this.$message.warning(res.message)
                }
              });
            }
          }
        })
      },
      deleteAddress(id){
        this.$confirm('是否删除该地址？', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.$https.post('/api/address/id/'+id,{}).then(res => {
            if(res.code == 0){
              this.$message.success("操作成功")
              this.getAddressList()
            }else{
              this.$message.warning(res.message)
            }
          });
        }).catch(() => {});
      },
      update(obj){
        this.editId = obj.id
        let tempArr = obj.areaCode.split(',')
        this.areaCode = [parseInt(tempArr[0]),parseInt(tempArr[1]),parseInt(tempArr[2])]
        //this.objData = obj

        this.objData.name = obj.name
        this.objData.phone = obj.phone
        this.objData.areaCode = obj.areaCode
        this.objData.areaName = obj.areaName
        this.objData.address = obj.address
        this.objData.isDefault = obj.isDefault
        
        this.dialogVisible = true
      },
      closeAdd(){
        this.$refs.form.resetFields()
        this.editId = ""
        this.areaCode = []
        this.objData.name = ''
        this.objData.phone = ''
        this.objData.areaCode = ''
        this.objData.areaName = ''
        this.objData.address = ''
        this.objData.isDefault = 2
        this.dialogVisible = false
      },
      newAddress(){
        if (this.addrelistData.length > 2) {
          this.$message.warning("最多使用三个地址,请删除一个地址")
          return
        }
        this.dialogVisible = true
      },
      //返回
      goBack(){
        this.$router.go(-1)
      },
      //确认下单
      confirmOrder(){
        if (this.deliverId === null) {
          this.$message.warning("请选择收货方式")
          return
        }
        let data = {}
        if (this.deliverId === 0) {
          data.deliveryType = 1
        }else{
          data.deliveryType = 2
          for (var i = 0; i < this.addrelistData.length; i++) {
            let row = this.addrelistData[i]
            if(row.id == this.deliverId){
              data.address = row.areaName.replace(/,/g,'')+row.address
              data.name = row.name
              data.phone = row.phone
            }
          }
        }
        data.goodsOrderDetails = this.goodsOrderDetails
        data.memberId = this.userData.id
        data.remark = this.remark
        data.cartIds = this.cartIds.join(',')
        data.payType = this.payType
        this.$https.post('/api/goodsOrder/addGoodsOrder',data).then(res => {
          if(res.code == 0){
            this.$message.success("操作成功")
            this.$router.replace({
              path:'/proOrderDetail/'+res.data,
            })
            //this.getAddressList()
          }else{
            this.$message.warning(res.message)
          }
        });
      }
    }
  }
</script>

<style scoped>
  .fenceTitle{
    height: 58px;
    line-height: 58px;
    position: relative;
    padding-left: 30px;
    margin: 0 17px;
    font-size: 18px;
    color: #343434;
  }
  .fenceTitle::before{
    content: " ";
    display: inline-block;
    width: 13px;
    height: 13px;
    background: #5680F9;
    border-radius: 50%;
    position: absolute;
    left: 0px;
    top: 22px;
  } 
  .addressBox{
    width: 816px;
    margin-left: 17px;
  } 
  .addressBox .addressItem{
    padding-left: 53px;
    padding-right: 40px;
    height: 48px;
    line-height: 48px;
    font-size: 14px;
    border: 1px solid #E5E5E5;
    position: relative;
  }
  .addressBox .addressItem p{
    float: left;
    height: 48px;
    line-height: 48px;
    width: 560px;
    overflow: hidden;
    text-overflow:ellipsis;
    white-space: nowrap;
  }
  .addressBox .addressItem + .addressItem{
    margin-top: 15px;
  }
  .addressBox .addressItem .selecteBtn{
    display: block;
    width: 18px;
    height: 18px;
    border: 1px solid #5680F9;
    border-radius: 50%;
    position: absolute;
    top: 15px;
    left: 17px;
    cursor: pointer;
  }
  .addressBox .addressItem .selecteBtn.active::after{
    display: block;
    content: " ";
    width: 14px;
    height: 14px;
    background: #5680F9;
    border-radius: 50%;
    position: absolute;
    top: 2px;
    left: 2px;
  }
  .addressBox .addressItem .deleteBtn{
    width: 37px;
    height: 46px;
    display: block;
    border-left: 1px solid #E5E5E5;
    position: absolute;
    top: 1px;
    right: 1px;
    cursor: pointer;
    background: url("../assets/images/addressDelete.png") no-repeat center;
  }
  .addressBox .addressItem .eidt{
    float: right;
    text-decoration: underline;
    color: #5680F9;
    font-size: 14px;
    margin: 0 10px;
    cursor: pointer;
  }
  .addressBox .addressItem .defalse{
    float: right;
    color: #FFCD30;
    font-size: 14px;
    margin: 0 10px;
  }
  .addressBox .useNewAdd{
    height: 51px;
    line-height: 51px;
    padding: 0 16px;
    font-size: 12px;
    color: #929292;
  }
  .addressBox .useNewAdd span{
    color: #5680F9;
    font-size: 14px;
    margin-right: 20px;
    text-decoration: underline;
    cursor: pointer;
  }
  .listTh{
    width:816px;
    text-align: center;
    height:36px;
    line-height: 36px;
    font-size: 14px;
    color: #363636;
    background: #F4F7FF;
    border:1px solid rgba(86,128,249,1);
    border-top: 3px solid rgba(86,128,249,1);
    margin: 0px 0 0 16px;
  }
  .orderList{
    width: 818px;
    padding: 0px 0 0 16px;
  }
  .orderList .itemT{
    height: 32px;
    line-height: 32px;
    padding-left: 24px;
    background: #FFFFFF;
    font-size: 12px;
    color: #666666;
    border: 1px solid #E5E5E5;
  }
  .orderList .itemC{
    padding: 12px 0px;
    background: #FBFBFB;
    border: 1px solid #E5E5E5;
    border-top: 0px;
    position: relative;
  }
  .orderList .itemC .opBtn{
    display: block;
    width: 85px;
    height: 27px;
    line-height: 26px;
    text-align: center;
    background: #FFCD30;
    border-radius: 4px;
    color: #FFFEFE;
    font-size: 16px;
    position: absolute;
    bottom: 12px;
    cursor: pointer;
  }
  .orderList .itemC .opBtn.cancel{right: 16px;}
  .orderList .itemC .opBtn.pay{right: 130px;}
  .orderList .proInfo+.proInfo{
    margin-top: 9px;
  }
  .orderList .imgBox{
    width: 118px;
    height: 91px;
    margin-left: 12px;
    float: left;
    background: #FFFFFF;
    border: 1px solid #E5E5E5;
  }
  .orderList .imgBox img{
    width: 100%;
    height: 100%;
  }
  .orderList .infoBox{
    padding: 8px 0 0 142px;
  }
  .orderList .infoBox .p1{
    height: 32px;
    overflow: hidden;
    font-size: 12px;
    color: #666666;
    line-height: 16px;
  }
  .orderList .infoBox .p2{
    margin-top: 20px;
    font-size: 12px;
    color: #919191;
  }
  .orderList .itemTd{
    height: 48px;
    line-height: 48px;
    text-align: center;
    font-size: 14px;
  }
  .orderList .price{
    color: #919191;
  }
  .orderList .num{
    color: #666666;
  }
  .orderList .pay{
    color: #E50001;
  }
  .orderList .operation{
    height: 27px;
    line-height: 27px;
  }
  .orderList .operation span{
    text-decoration: underline;
    cursor: pointer;
    color: #5680F9;
  }
  .priceInfo{
    margin: 0 13px;
    line-height: 30px;
    color: #666666;
    font-size: 14px;
  }
  .btn-box{
    padding: 23px 13px 10px;
    text-align: right;
  }
  .userInfoBox{
    width: 454px;
    padding-top: 24px;
  }
  .editBtn{
    position: absolute;
    color: #5680f9;
    right: 20px;
    top: 14px;
    font-size: 16px;
    cursor: pointer;
  }
  .subTitle{
    padding: 10px 0 0 15px;
    height: 52px;
    line-height: 52px;
    font-size: 18px;
    color: #333333;
  }
  .subTitle span{
    display: inline-block;
    width: 13px;
    height: 13px;
    background: #5680F9;
    border-radius: 50%;
    margin-right: 15px;
  }
  .defaultAddress{
    line-height: 32px;
  }
  .defaultAddress i{
    display: inline-block;
    width: 18px;
    height: 18px;
    border: 1px solid #5680F9;
    border-radius: 50%;
    position: relative;
    top: 4px;
    cursor: pointer;
  }
  .defaultAddress i.active:after{
    content: " ";
    position: absolute;
    top: 2px;
    left: 2px;
    width: 14px;
    height: 14px;
    background: #5680F9;
    border-radius: 50%;
  }
  .defaultAddress span{
    display: inline-block;
    position: relative;
    margin-left: 5px;
    cursor: pointer;
    color: #919191;
    font-size: 12px;
  }
  .addBtn{
    margin-top: 15px;
  }
  .addBtn span{
    display: inline-block;
    line-height: 38px;
    text-align: center;
    width: 96px;
    height: 38px;
    border: 1px solid #E5E5E5;
    border-radius: 4px;
    cursor: pointer;
    color: #919191;
  }
  .addBtn span.save{
    border: 1px solid #FFCD30;
    background: #FFCD30;
    color: #ffffff;
    margin-right: 20px;
  }
  .addTip{
    line-height: 57px;
    color: #919191;
    font-size: 12px;
  }

  .radioPayFor{
    position: relative;
    background: #fff; 
    padding: 20px;
    margin:10px 0 0 17px;
    display:flex;
    align-items: center;
    border:1px solid #E5E5E5;
    width:775px;
   
  }
  .radioPayFor label{ 
     margin-right:50px;
     display:flex;
    align-items: center;
    position: relative;
  }
  .radioPayFor label:before{
    content : ''; 
    width:20px; height:20px; border-radius: 100%; border:solid #ccc 1px; margin-right:5px; position: relative; z-index: 1;
  }
  .radioPayFor label[sele="sele"]:before{
    border-color:#5680fa;
  }
  .radioPayFor label[sele="sele"]:after{
    content:'';position: absolute; z-index: 2; left:3px;  top:50%; transform: translateY(-50%); width:16px; height:16px;  background: #5680F9; border-radius: 100%;
  }
</style>



// WEBPACK FOOTER //
// src/components/proOrderConfirm.vue